import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
import { GameState } from '@utils/game/fruitRush/types.js';
import { GRID_SIZE, INITIAL_TARGET_SCORE, DIFFICULTY_MULTIPLIER, TILE_TYPES, INITIAL_TIME, TIME_BONUS_DEA_PER_LEVEL, MIN_INITIAL_TIME, TIME_BONUS_PER_TILE, ADV_PLAY_TIME, ADV_ROUND } from '@utils/game/fruitRush/constants.js';
import { audioService } from '@utils/game/fruitRush/audioService.js';
import { aesEncrypt, getRandomElement, isOpenMobile } from '@utils/index.js';
import { gameAdv } from "@utils/gameAdv.js";
import vailcode from "@utils/errcode";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "fruitRushPage",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    flatGrid() {
      return this.gameState.grid.flatMap((row, r) => row.map((tile, c) => ({
        ...tile,
        row: r,
        col: c
      })));
    },
    nextBtnText() {
      return (this.gameState.level + 1) % ADV_ROUND === 0 ? this.$lang('Continue (Ad)') : this.$lang('Next Level');
    }
  },
  data() {
    return {
      gameState: {
        ...GameState
      },
      maxRevives: 10,
      revives: 10,
      totalScore: 0,
      prizePool: 0,
      leftTime: 0,
      hint: null,
      timer: null,
      timeVal: null,
      stimeVal: null,
      timePeriod: '',
      popGameRankShow: false,
      popUserRewardShow: false,
      userReward: null,
      isShuffling: false,
      GRID_SIZE: GRID_SIZE,
      isGameOver: false,
      isLevelCleared: false,
      popWinShow: false,
      popStartShow: false,
      popLostShow: false,
      popOpenMobileShow: false,
      isClickAdv: false,
      ADV_PLAY_TIME: ADV_PLAY_TIME
    };
  },
  watch: {
    "gameState.score": {
      handler(newScore, oldScore) {
        if (this.gameState.targetScore > 0 && newScore >= this.gameState.targetScore) {
          this.isLevelCleared = true;
          this.popWinShow = true;
          clearTimeout(this.timer);
          this.playLevelUp();
        }
      },
      deep: true,
      immediate: true
    },
    totalScore: {
      handler() {
        clearTimeout(this.timeVal);
        this.timeVal = setTimeout(() => {
          console.log('score', this.totalScore);
          this.end();
        }, 200);
      }
    },
    "popGameRankShow": {
      handler(newVal, oldVal) {
        if (newVal) {
          clearTimeout(this.timer);
        } else {
          this.handleTimer();
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    try {
      clearTimeout(this.timer);
      clearTimeout(this.stimeVal);
      this.end();
    } catch (error) {}
    this.$nextTick(() => {
      next();
    });
  },
  methods: {
    playSelect() {
      audioService.playSelect();
    },
    playMatch() {
      audioService.playMatch();
    },
    playFail() {
      audioService.playFail();
    },
    playLevelUp() {
      audioService.playLevelUp();
    },
    isHint(r, c) {
      return this.hint?.from && this.hint.from.row === r && this.hint.from.col === c || this.hint?.to && this.hint.to.row === r && this.hint.to.col === c;
    },
    generateTile(row, col) {
      return {
        id: Math.random().toString(36).substr(2, 9),
        type: TILE_TYPES[Math.floor(Math.random() * TILE_TYPES.length)],
        row,
        col,
        isNew: true
      };
    },
    createInitialGrid() {
      let grid = [];
      for (let r = 0; r < this.GRID_SIZE; r++) {
        grid[r] = [];
        for (let c = 0; c < this.GRID_SIZE; c++) {
          grid[r][c] = this.generateTile(r, c);
        }
      }
      return grid;
    },
    checkMatches(currentGrid) {
      const matches = [];

      // Horizontal
      for (let r = 0; r < this.GRID_SIZE; r++) {
        let matchCount = 1;
        for (let c = 0; c < this.GRID_SIZE; c++) {
          if (c < this.GRID_SIZE - 1 && currentGrid[r][c]?.type === currentGrid[r][c + 1]?.type) {
            matchCount++;
          } else {
            if (matchCount >= 3) {
              for (let i = 0; i < matchCount; i++) {
                matches.push({
                  row: r,
                  col: c - i
                });
              }
            }
            matchCount = 1;
          }
        }
      }

      // Vertical
      for (let c = 0; c < this.GRID_SIZE; c++) {
        let matchCount = 1;
        for (let r = 0; r < this.GRID_SIZE; r++) {
          if (r < this.GRID_SIZE - 1 && currentGrid[r][c]?.type === currentGrid[r + 1][c]?.type) {
            matchCount++;
          } else {
            if (matchCount >= 3) {
              for (let i = 0; i < matchCount; i++) {
                matches.push({
                  row: r - i,
                  col: c
                });
              }
            }
            matchCount = 1;
          }
        }
      }
      return Array.from(new Set(matches.map(m => `${m.row}-${m.col}`))).map(s => {
        const [r, c] = s.split('-').map(Number);
        return {
          row: r,
          col: c
        };
      });
    },
    findPossibleMove(currentGrid) {
      const testSwap = (r1, c1, r2, c2) => {
        const tempGrid = currentGrid.map(row => [...row]);
        const t1 = tempGrid[r1][c1];
        const t2 = tempGrid[r2][c2];
        if (!t1 || !t2) return false;
        tempGrid[r1][c1] = {
          ...t2,
          row: r1,
          col: c1
        };
        tempGrid[r2][c2] = {
          ...t1,
          row: r2,
          col: c2
        };
        return this.checkMatches(tempGrid).length > 0;
      };
      for (let r = 0; r < this.GRID_SIZE; r++) {
        for (let c = 0; c < this.GRID_SIZE; c++) {
          if (c < this.GRID_SIZE - 1 && testSwap(r, c, r, c + 1)) return {
            from: {
              r,
              c
            },
            to: {
              r,
              c: c + 1
            }
          };
          if (r < this.GRID_SIZE - 1 && testSwap(r, c, r + 1, c)) return {
            from: {
              r,
              c
            },
            to: {
              r: r + 1,
              c
            }
          };
        }
      }
      return null;
    },
    handleShuffle() {
      this.isShuffling = true;
      setTimeout(() => {
        let newGrid = this.createInitialGrid();
        while (this.checkMatches(newGrid).length > 0 || !this.findPossibleMove(newGrid)) {
          newGrid = this.createInitialGrid();
        }
        this.gameState.grid = newGrid;
        setTimeout(() => {
          this.handleProcessGrid(this.gameState.grid);
          this.isShuffling = false;
        }, 150);
      }, 1000);
    },
    async handleProcessGrid(currentGrid, accumulatedScore = 0, accumulatedTimeBonus = 0) {
      const matches = this.checkMatches(currentGrid);
      if (matches.length === 0) {
        const move = this.findPossibleMove(currentGrid);
        this.gameState.isProcessing = false;
        this.gameState.score = this.gameState.score + accumulatedScore;
        this.totalScore = this.totalScore + accumulatedScore;
        this.gameState.timeLeft = this.gameState.timeLeft + accumulatedTimeBonus;
        if (!move) {
          this.handleShuffle();
        }
        return;
      }
      this.playMatch();
      const matchScore = matches.length * 10;
      const timeBonus = matches.length * TIME_BONUS_PER_TILE - 1;
      const gridAfterMatch = [...currentGrid.map(row => [...row])];
      matches.forEach(m => {
        gridAfterMatch[m.row][m.col] = null;
      });
      this.gameState.grid = gridAfterMatch;
      setTimeout(() => {
        const droppedGrid = [...gridAfterMatch.map(row => [...row])];
        for (let c = 0; c < this.GRID_SIZE; c++) {
          let emptySpaces = 0;
          for (let r = GRID_SIZE - 1; r >= 0; r--) {
            if (droppedGrid[r][c] === null) {
              emptySpaces++;
            } else if (emptySpaces > 0) {
              const tile = droppedGrid?.[r]?.[c] || {};
              droppedGrid[r + emptySpaces][c] = {
                ...tile,
                row: r + emptySpaces
              };
              droppedGrid[r][c] = null;
            }
          }
          for (let r = 0; r < emptySpaces; r++) {
            droppedGrid[r][c] = this.generateTile(r, c);
          }
        }
        this.gameState.grid = droppedGrid;
        setTimeout(() => this.handleProcessGrid(droppedGrid, accumulatedScore + matchScore, accumulatedTimeBonus + timeBonus), 300);
      }, 300);
    },
    swapTiles(r1, c1, r2, c2) {
      if (this.gameState.isProcessing || this.isShuffling || this.isGameOver) return;
      const newGrid = [...this.gameState.grid.map(row => [...row])];
      const t1 = newGrid[r1][c1];
      const t2 = newGrid[r2][c2];
      if (!t1 || !t2) return;
      newGrid[r1][c1] = {
        ...t2,
        row: r1,
        col: c1
      };
      newGrid[r2][c2] = {
        ...t1,
        row: r2,
        col: c2
      };
      const matches = this.checkMatches(newGrid);
      if (matches.length > 0) {
        this.gameState.grid = newGrid;
        setTimeout(() => {
          this.handleProcessGrid(newGrid);
          this.gameState.selectedTile = null;
          this.gameState.isProcessing = true;
          this.hint = null;
        }, 150);
      } else {
        this.playFail();
        this.gameState.grid = newGrid;
        this.gameState.selectedTile = null;
        //this.gameState.timeLeft = (this.gameState.timeLeft - TIME_BONUS_PER_TILE * 3) >=0 ? this.gameState.timeLeft - TIME_BONUS_PER_TILE * 3 : 0;
        setTimeout(() => {
          const revertGrid = [...newGrid.map(row => [...row])];
          revertGrid[r1][c1] = t1;
          revertGrid[r2][c2] = t2;
          this.gameState.grid = revertGrid;
        }, 200);
      }
    },
    handleTileClick(row, col) {
      console.log('handleTileClick', this.gameState.isProcessing, this.isGameOver, this.isLevelCleared, this.isShuffling);
      if (this.gameState.isProcessing || this.isGameOver || this.isLevelCleared || this.isShuffling) return;
      this.playSelect();
      if (!this.gameState.selectedTile) {
        this.gameState.selectedTile = {
          row,
          col
        };
      } else {
        const {
          row: pr,
          col: pc
        } = this.gameState.selectedTile;
        const isAdjacent = Math.abs(pr - row) + Math.abs(pc - col) === 1;
        if (isAdjacent) {
          this.swapTiles(pr, pc, row, col);
        } else {
          this.gameState.selectedTile = {
            row,
            col
          };
        }
      }
    },
    requestHint() {
      if (this.gameState.isProcessing || this.isShuffling || this.isGameOver) return;
      const move = this.findPossibleMove(this.gameState.grid);
      if (move) {
        this.hint = {
          from: {
            row: move.from.r,
            col: move.from.c
          },
          to: {
            row: move.to.r,
            col: move.to.c
          }
        };
        // Clear hint after 2 seconds
        setTimeout(() => this.hint = null, 2000);
      }
    },
    async startNextLevel() {
      const callback = async res => {
        this.popWinShow = false;
        await this.start();
        this.gameState.level = this.gameState.level + 1;
        this.gameState.score = 0;
        this.gameState.targetScore = Math.round(this.gameState.targetScore * DIFFICULTY_MULTIPLIER);
        this.gameState.timeLeft = INITIAL_TIME - (this.gameState.level - 1) * TIME_BONUS_DEA_PER_LEVEL >= MIN_INITIAL_TIME ? INITIAL_TIME - (this.gameState.level - 1) * TIME_BONUS_DEA_PER_LEVEL : MIN_INITIAL_TIME;
        this.gameState.grid = this.createInitialGrid();
        this.isGameOver = false;
        this.isLevelCleared = false;
        this.isShuffling = false;
        setTimeout(() => {
          this.gameState.isProcessing = true;
          this.handleProcessGrid(this.gameState.grid);
          this.gameState.isProcessing = false;
        }, 500);
        this.hint = null;
        this.handleTimer();
      };
      if ((this.gameState.level + 1) % ADV_ROUND === 0) {
        let advData = getRandomElement(this.advList);
        if (advData) {
          gameAdv.show(advData, this.timePeriod, res => {
            callback(res);
          }, this);
        } else {
          callback(null);
        }
      } else {
        callback();
      }
    },
    async restartGame() {
      this.popLostShow = false;
      this.popWinShow = false;
      this.popStartShow = false;
      await this.start();
      this.gameState.level = 1;
      this.gameState.score = 0;
      this.revives = this.maxRevives;
      this.totalScore = 0;
      this.gameState.targetScore = INITIAL_TARGET_SCORE;
      this.gameState.grid = this.createInitialGrid();
      this.gameState.selectedTile = null;
      this.gameState.timeLeft = INITIAL_TIME;
      this.isGameOver = false;
      this.isLevelCleared = false;
      this.isShuffling = false;
      setTimeout(() => {
        this.gameState.isProcessing = true;
        this.handleProcessGrid(this.gameState.grid);
        this.gameState.isProcessing = false;
      }, 500);
      this.hint = null;
      this.handleTimer();
    },
    async start() {
      let rs = await this.$http.post("/game/start", {
        game_type: "fruitRush"
      });
      vailcode(rs, () => {
        this.prizePool = rs.data.keys ?? 0;
        this.timePeriod = rs.data.time_period ?? "";
        this.leftTime = rs.data.left_time ?? 0;
        this.lastScore = rs.data.last_score ?? 0;
        this.countDown();
      });
    },
    async end() {
      if (this.lastScore >= this.totalScore) return;
      let gameData = aesEncrypt(JSON.stringify({
        game_type: "fruitRush",
        level: this.gameState.level,
        score: this.totalScore,
        time_period: this.timePeriod,
        time: new Date().getTime()
      }));
      let rs = await this.$http.post("/game/score", {
        gameData: gameData,
        '_n': 1
      });
      if (rs.code == 0) {
        // this.level = rs.data.level ?? 1;
        // this.score = rs.data.score ?? 0;
        this.prizePool = rs.data.keys ?? 0;
      }
    },
    async init() {
      let rs = await this.$http.post("/game/init", {
        game_type: "fruitRush"
      });
      vailcode(rs, () => {
        this.leftTime = rs.data.left_time ?? 0;
        this.prizePool = rs.data.keys ?? 0;
        this.advList = rs.data.advList ?? [];
        this.timePeriod = rs.data.time_period ?? "";
        this.leftTime = rs.data.left_time ?? 0;
        this.userReward = rs.data.userReward ?? null;
        if (this.userReward?.total_keys > 0 || this.userReward?.total_taps > 0) {
          setTimeout(() => {
            this.popUserRewardShow = true;
          }, 500);
        }
        this.countDown();
      });
    },
    async handleTimer() {
      // 避免重复创建计时器
      clearTimeout(this.timer);
      this.gameState.timeLeft = this.gameState.timeLeft - 1;
      this.$nextTick(() => {
        if (this.gameState.timeLeft <= 0) {
          this.popLostShow = true;
          this.isGameOver = true;
        } else {
          this.timer = setTimeout(() => {
            this.handleTimer();
          }, 1000);
        }
      });
    },
    countDown() {
      clearTimeout(this.stimeVal);
      this.leftTime = this.leftTime - 1;
      this.$nextTick(() => {
        if (this.leftTime <= 0) {
          this.isGameOver = true;
          this.popStartShow = true;
          this.init();
        } else {
          this.stimeVal = setTimeout(() => {
            this.countDown();
          }, 1000);
        }
      });
    },
    async handleGetRewardConfirm() {
      let rs = await this.$http.post("/game/get/reward", {
        game_type: "fruitRush"
      });
      vailcode(rs, () => {
        this.popUserRewardShow = false;
      });
    },
    async handPlayAdv() {
      // if(this.isClickAdv) return;
      // this.isClickAdv = true;
      if (this.revives <= 0) return;
      const callback = res => {
        this.isClickAdv = false;
        if (res && res.code == 0) {
          this.prizePool = res.data.keys;
        }
        this.gameState.timeLeft = ADV_PLAY_TIME;
        this.gameState.isProcessing = false;
        this.isGameOver = false;
        this.isLevelCleared = false;
        this.isShuffling = false;
        this.popLostShow = false;
        this.revives--;
        this.handleTimer();
      };
      let advData = getRandomElement(this.advList);
      if (advData) {
        gameAdv.show(advData, this.timePeriod, res => {
          callback(res);
        }, this);
      } else {
        callback(null);
      }
    },
    handleCancel() {
      this.restartGame();
    },
    handleConfirm() {
      this.revives > 0 ? this.handPlayAdv() : this.restartGame();
    },
    viewRank() {
      this.$nextTick(() => {
        //  this.$router.push(`/game/rank`)
        //  console.log(this.$router)
        this.popGameRankShow = true;
      });
    }
  },
  async mounted() {
    if (!isOpenMobile()) {
      this.popOpenMobileShow = true;
      return;
    }
    await this.init();
    this.popStartShow = true;
  }
};